import { useState, useEffect, ReactNode } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import icons
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { CirclePlus, ArrowUpRight } from "lucide-react";
// import images
import drugBaseImg from "../../image/drugomics/drug-design-base.png";
import drugPillImg from "../../image/drugomics/drug-design-pill.png";
import vaccineBaseImg from "../../image/drugomics/vaccine-design-base.png";
import vaccineSyringeImg from "../../image/drugomics/vaccine-design-syringe.png";
import medicineBaseImg from "../../image/drugomics/medicine-base.png";
import medicineHelixImg from "../../image/drugomics/medicine-helix.png";
import dotsImage from "../../image/drugomics/3dots.svg";
// import data
import servicesData from "../../data/content/drugomics/drugServices.json";

import drugPipelineData from "../../data/content/drugomics/drugPipeline.json";

import { DataFlat, DataStructure, DataKeys } from '../../types';
// import components
import { TitleSubtitle, CapsText } from "../display/TextFormat";
import { SpacingFrame } from "../display/Frame";
// import context
import { useLang, useScreenSize } from "../Context";
// import global var
import { typedVocab } from "../GlobalVar";
import parse from "html-react-parser";

const typedDrugPipeline : DataStructure = drugPipelineData;
const typedServices : DataStructure = servicesData;

interface DrugPipelineProps {
    showAll?: boolean;
};
export default function DrugPipeline({ showAll } : DrugPipelineProps) {
    const { lang } = useLang();

    let typedDrugPipelineTitle = typedDrugPipeline["Pipeline Title"][lang];
    let typedDrugPipelineSubTitle = typedDrugPipeline["Pipeline SubTitle"][lang];

    let typedDrugPipelineContentTitle = typedDrugPipeline["Common Disease Pipeline"]["title"][lang];
    let typedDrugPipelineContentTitle2 = typedDrugPipeline["Rare Disease Pipeline"]["title"][lang];
    let typedDrugPipelineContent = typedDrugPipeline["Common Disease Pipeline"]["pipeline"];
    let typedDrugPipelineContent2 = typedDrugPipeline["Rare Disease Pipeline"]["pipeline"];
    let typedDrugPipelineColor = typedDrugPipeline["Common Disease Pipeline"]["pipelinecolor"];
    let typedDrugPipelineColor2 = typedDrugPipeline["Rare Disease Pipeline"]["pipelinecolor"];

    let data = showAll ? typedDrugPipelineContent : Object.keys(typedDrugPipelineContent).slice(0, 10);
    let data2 = showAll ? typedDrugPipelineContent2 : Object.keys(typedDrugPipelineContent2).slice(0, 10);
    // console.log(data)
    // console.log(Object.keys(typedDrugPipeline).slice(0, 9))
    // console.log(typedDrugPipeline[0])
    let content2 = Object.keys(data2).map((i) => {
        return (
            <Rows data={typedDrugPipelineContent2[i]} color={typedDrugPipelineColor2} />
        )   
    });
    let content = Object.keys(data).map((i) => {
        return (
            <Rows data={typedDrugPipelineContent[i]} color={typedDrugPipelineColor} />
        )   
    });
    
    return (
        <SpacingFrame>

                <div className="flex flex-col-reverse lg:flex-row items-start gap-8">
                <div className="w-full lg:w-2/3">
                    <TitleSubtitle 
                    title={typedDrugPipelineTitle}
                    subtitle={typedDrugPipelineSubTitle}
                    left
                    spacing={12}
                    />
                </div>
                <div className="w-full lg:w-1/3 flex justify-end">
                <img src={dotsImage} alt="" />
                </div>
                </div>


            <div style={{ margin: "5px 0" }} />

            <div className="flex items-center gap-4 justify-between">
            <p className="text-xl font-semibold text-left">
            <span className="text-purple-400">---</span>
            </p>

            <p className="text-xl font-semibold text-right whitespace-pre-line">
            {parse(typedDrugPipelineContentTitle2)}
            </p>
            </div>
            <>
                <Header />
                <SpacingFrame>
                    { content2 }
                </SpacingFrame>
            </>


            <div style={{ margin: "15px 0" }} />
            

            <div className="flex items-center justify-between">
            <p className="text-xl font-semibold text-left whitespace-pre-line">
            {parse(typedDrugPipelineContentTitle)}
            </p>

            <p className="text-xl font-semibold text-teal-300">---</p>
            </div>
            <>
                <Header />
                <SpacingFrame>
                    { content }
                </SpacingFrame>
            </>

            
        </SpacingFrame>
    )
};

interface TableStructureProps {
    children: ReactNode;
};
function TableStructure({ children } : TableStructureProps) {
    return (
        <div className="w-full h-fit grid grid-cols-4 gap-6">
            { children }
        </div>
    )
};

function Header() {
    return (
        <TableStructure>
            <div className="col-span-1 lg:py-6 sm:py-2 break-words m-auto">
                <CapsText text="Disease Area" style="lg:text-sm sm:text-2xs font-bold" />
            </div>
            <div className="col-span-3 w-full m-auto">
                <div className="grid grid-cols-5 items-end border-b-2 lg:gap-10 sm:gap-4 lg:py-6 sm:py-4 lg:break-normal sm:break-words">
                    <CapsText text="TARGET ID" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" />
                    {/* <CapsText text="LEAD VALIDATION" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" />
                    <CapsText text="PILOT STUDY" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" /> */}
                    
                    <CapsText text="IN-VITRO VERFICATION" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" /> 
                    <CapsText text="ANIMAL POC" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" />
                    <CapsText text="PRECLINICAL/IND READY" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" />
                    <CapsText text="CLINICAL" style="lg:text-sm sm:text-2xs font-bold lg:[writing-mode:horizontal-tb] lg:rotate-0 sm:[writing-mode:vertical-lr] sm:rotate-180" />
                </div>
            </div>
        </TableStructure>
    )
};

interface RowsProps {
    data: DataStructure;
    color?: string;
};
function Rows({ data, color = "teal" } : RowsProps) {
    
    const { lang } = useLang();
    const { screenSize } = useScreenSize();
    const [showIcon, setShowIcon] = useState<boolean>(true);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    const [link, setLink] = useState<string>("");

    useEffect(() => {
        if (screenSize === "Small") {
            setShowIcon(false);
        } else {
            setShowIcon(true);
        };
    }, [screenSize])


    useEffect(() => {
        if (data) {
            let fixedLink = data["link"];
            if (lang === "Zh") {
                if (fixedLink.startsWith("/")) {
                    setLink("/tw" + fixedLink);
                } else {
                    setLink("" + fixedLink);
                };
            } else if (lang === "Jp") {
                if (fixedLink.startsWith("/")) {
                    setLink("/jp" + fixedLink);
                } else {
                    setLink("" + fixedLink);
                };
            } else {
                setLink("" + fixedLink);
            };
        }; 
    }, [data, lang]);

    // data
    let label = data["title"][lang];
    let info = data["text"][lang];
    let percent = Number(data["percentage"]);
    //let link = data["link"];
    const hoverStyle = "hover:text-teal-400 hover:underline hover:decoration-teal-400";

    return (
        <TableStructure>
            <div className="col-span-1 flex items-center justify-center gap-2 justify-self-end">
                
                { !link && 
                  <p className="lg:text-sm sm:text-xs text-right">{ label }</p> 
                }
                
                { link &&
                    <Link to={link} className={`lg:text-sm sm:text-xs text-right ${hoverStyle}`}>
                        { label }
                    </Link>
                }

                { showIcon && 
                    <div className="relative h-fit w-fit">
                        <CirclePlus className="cursor-pointer hover:rounded-full hover:bg-grey-100 duration-200 ease-in-out" 
                            color={"#757575"} width={16} height={16} 
                            onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}
                        />
                        { showTooltip && <ToolTip text={ info } /> }
                    </div>
                }
            </div>
            <div className="col-span-3 w-full m-auto">
                <ProgressBar percentage={percent} color={color}/>
            </div>
        </TableStructure>
    )
};

interface ProgressBarProps {
    percentage: number;
    color?: string;
};
function ProgressBar({ percentage, color = "teal" } : ProgressBarProps) {
    const gradientMap = {
        15: `to-${color}-300`,
        18: `to-${color}-300`,
        20: `to-${color}-300`,
        24: `to-${color}-300`,
        30: `to-${color}-300`,
        33: `to-${color}-300`,
        40: `to-${color}-300`,
        47: `to-${color}-300`,
        48: `to-${color}-300`,
        50: `to-${color}-300`,
        57: `to-${color}-300`,
        60: `to-${color}-400`,
        67: `to-${color}-400`,
        70: `to-${color}-400`,
        75: `to-${color}-400`,
        80: `to-${color}-400`,
        100: `to-${color}-500`
    } as DataFlat;

    return (
        <div className="relative w-full h-8 rounded-full bg-grey-100">
            <motion.div className={`absolute h-8 rounded-full bg-gradient-to-r from-${color}-100 ${gradientMap[percentage]}`} style={{ width: `${percentage}%` }} 
                initial={{ width: "40px" }}
                whileInView={{ width: `${percentage}%` }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.5 }}
            />
        </div>
    )
};

interface ToolTipProps {
    text: string;
};
function ToolTip({ text } : ToolTipProps) {
    const { lang } = useLang();
    return (
        <motion.div className="absolute bottom-0 -translate-x-[82.5px] -translate-y-[16px] z-50 pb-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
        >
            <div className="relative">
                <div className="w-[180px] h-fit grid grid-flow-row auto-rows-min gap-1 bg-white rounded-lg shadow-lg px-4 py-3 m-auto">
                    <p className="text-xs font-medium">{ typedVocab["Advantages"][lang] }</p>
                    <p className="text-xs text-grey-400">{ text }</p>
                </div>
                <div className="absolute w-full -bottom-2">
                    <FontAwesomeIcon className="text-2xl text-white" icon={faSortDown} />
                </div>
            </div>
        </motion.div>
    )
};


export function DrugDesignSection() {
    let serviceCards = Object.keys(typedServices).map((i) => {
        let data = typedServices[i];
        data["key"] = i;
        return (
            <DrugomicsCard data={data} />
        )
    });

    return (
        <div className="w-full mt-12 flex gap-6 lg:flex-row sm:flex-col">
            { serviceCards }
        </div>
    )
}

interface DrugomicsCard {
    data: DataKeys;
};
function DrugomicsCard({ data } : DrugomicsCard) {
    const [key, setKey] = useState<string>("");
    const [imageAnim, setImageAnim] = useState<ReactNode>(<></>);
    const [title, setTitle] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [link, setLink] = useState<string>("");
    const [hover, setHover] = useState<boolean>(false);
    const { lang } = useLang();

    useEffect(() => {
        if (data) {
            setKey(data["key"]);
            setTitle(data["title"][lang]);
            setText(data["text"][lang]);
            setLink(data["link"]);
        }; 
    }, [data, key, lang]);

    useEffect(() => {
        if (key === "drug-design") {
            setImageAnim(<DrugDesignTransition isHover={hover} />);
        } else if (key === "vaccine-design") {
            setImageAnim(<VaccineDesignTransition isHover={hover} />);
        } else if (key === "personalized-medicine") {
            setImageAnim(<PersonalizedMedTransition isHover={hover} />);
        } else {
            setImageAnim(<></>);
        };
    }, [key, hover]);

    return (
        <Link to={link} className="w-fit min-w-[250px] sm:w-[250px] h-fit min-h-[300px] grid grid-flow-row auto-rows-min gap-3 py-6 rounded-2xl m-auto
                                    group hover:bg-white transition-all duration-300 cursor-pointer"
            onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
        >
            { imageAnim }
            <div className="w-full h-min flex items-center justify-center gap-2 text-md">
                <p className="w-fit font-bold group-hover:text-teal-500">{ title }</p>
                <ArrowUpRight className="group-hover:text-teal-500" size={25} />
            </div>
            <p className="text-sm text-grey-400 group-hover:text-teal-500">{ text }</p>
        </Link>
    )
};

export function OtherDrugServicesCard({ data } : DrugomicsCard) {
    const [key, setKey] = useState<string>("");
    const [imageAnim, setImageAnim] = useState<ReactNode>(<></>);
    const [title, setTitle] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [link, setLink] = useState<string>("");
    const [hover, setHover] = useState<boolean>(false);
    const { lang } = useLang();

    useEffect(() => {
        if (data) {
            setKey(data["key"]);
            setTitle(data["title"][lang]);
            setText(data["text"][lang]);
            let fixedLink = data["absoluteLink"];
            if (lang === "Zh") {
                setLink("/tw" + fixedLink);
            } else if (lang === "Jp") {
                setLink("/jp" + fixedLink);
            } else {
                setLink(fixedLink)
            };
        }; 
    }, [data, key, lang]);

    useEffect(() => {
        if (key === "drug-design") {
            setImageAnim(<DrugDesignTransition isHover={hover} />);
        } else if (key === "vaccine-design") {
            setImageAnim(<VaccineDesignTransition isHover={hover} />);
        } else if (key === "personalized-medicine") {
            setImageAnim(<PersonalizedMedTransition isHover={hover} />);
        } else {
            setImageAnim(<></>);
        };
    }, [key, hover]);

    return (
        <Link to={link} className="min-w-[240px] max-w-[460px] w-fit h-fit grid grid-cols-3 place-items-center gap-4 p-6 rounded-2xl m-auto
                        group hover:bg-white transition-all duration-300 cursor-pointer"
                onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}        
        >
            <div className="col-span-1">
                { imageAnim }
            </div>
            <div className="col-span-2 flex flex-col gap-2">
                <div className="w-fit flex items-center justify-center gap-2">
                    <p className="text-left text-lg font-semibold">{ title }</p>
                    <ArrowUpRight size={25} />
                </div>
                <p className="text-left text-sm text-grey-400">{ text }</p>
            </div>
        </Link>
    )
};


//////////////////////
// ANIMATED IMAGES //
/////////////////////
interface TransitionFrameProps {
    children: ReactNode;
};
function TransitionFrame({ children } : TransitionFrameProps) {
    const { screenSize } = useScreenSize();
    const [size, setSize] = useState<number>(128);

    useEffect(() => {
        if (screenSize === "Large") {
            setSize(128);
        } else if (screenSize === "Small") {
            setSize(112);
        };
    }, [screenSize]);

    return (
        <div className="relative m-auto overflow-hidden" style={{ width: `${size}px`, height: `${size}px` }}>
            { children }
        </div>
    )
};

interface TransitionProps {
    isHover: boolean;
};
function DrugDesignTransition({ isHover } : TransitionProps) {
    const [hover, setHover] = useState<boolean>(false);

    useEffect(() => {
        setHover(isHover);
    }, [isHover]);

    const initialPosition = { x: 0, y: 0 }; 
    const finalPosition = { x: -45, y: -28, rotate: -90 };

    return (
        <TransitionFrame>
            <img src={drugBaseImg} alt="backgroundImg" className="absolute w-full h-full" />
            <motion.img
                src={drugPillImg}
                alt="Moving Component"
                initial={ initialPosition }
                animate={ hover ? finalPosition : initialPosition }
                transition={{ type: 'spring', stiffness: 200, damping: 20 }}
                style={{ position: 'absolute', width: 'auto', height: 'auto' }}
            />
        </TransitionFrame>
    );
};

function VaccineDesignTransition({ isHover } : TransitionProps) {
    const [hover, setHover] = useState<boolean>(false);

    useEffect(() => {
        setHover(isHover);
    }, [isHover]);

    const initialPosition = { x: 0, y: 0 }; 
    const finalPosition = { x: 8, y: -5, rotate: 18 };

    return (
        <TransitionFrame>
            <img src={vaccineBaseImg} alt="backgroundImg" className="absolute w-full h-full" />
            <motion.img
                src={vaccineSyringeImg}
                alt="Moving Component"
                initial={ initialPosition }
                animate={ hover ? finalPosition : initialPosition }
                transition={{ type: 'spring', stiffness: 200, damping: 20 }}
                style={{ position: 'absolute', width: 'auto', height: 'auto' }}
            />
        </TransitionFrame>
    );
};

function PersonalizedMedTransition({ isHover } : TransitionProps) {
    const [hover, setHover] = useState<boolean>(false);

    useEffect(() => {
        setHover(isHover);
    }, [isHover]);

    const initialPosition = { x: 0, y: 0 }; 
    const finalPosition = { x: 0, y: 0, rotateY: 180 };

    return (
        <TransitionFrame>
            <img src={medicineBaseImg} alt="backgroundImg" className="absolute w-full h-full" />
            <motion.img
                src={medicineHelixImg}
                alt="Moving Component"
                initial={ initialPosition }
                animate={ hover ? finalPosition : initialPosition }
                transition={{ type: 'spring', stiffness: 100, damping: 20 }}
                style={{ position: 'absolute', width: 'auto', height: 'auto' }}
            />
        </TransitionFrame>
    );
};


